import { useQuery, useMutation } from '@tanstack/react-query';
import clientPortalAxiosInstance from '../../common/utilities/axios/clientPortalAxiosInstance';
import sleep from 'sleep-promise';

export const useViewThoughtLeadershipResourcesListQuery = () => {
  return useQuery({
    queryKey: ['viewThoughtLeadershipResourcesListQuery'],
    queryFn: () => {
      // sleep(2000);
      return clientPortalAxiosInstance
        .get(`/Reports-Resources/report/getAllAdminThoughtLeadershipResource`)
        .then((res) => res.data)
    },
  })
}

export const useGetThoughtLeadershipResourcesBySitecoreIdQuery = ({ sitecoreId }) => {
  return useQuery({
    queryKey: ['getThoughtLeadershipResourcesBySitecoreIdQuery', `${sitecoreId}`],
    queryFn: () => {
      // sleep(2000);
      return clientPortalAxiosInstance
        .get(`/Reports-Resources/report/getAllAdminThoughtLeadershipResource/${sitecoreId}`)
        .then((res) => {
          return res.data
        })
    },
    // The query will not execute until the sitecoreId exists
    enabled: !!sitecoreId,
  })
}

export const useGetThoughtLeadershipResourcesTypeListQuery = () => {
  return useQuery({
    queryKey: ['getThoughtLeadershipResourcesTypeListQuery'],
    queryFn: () => {
      // sleep(2000);
      return clientPortalAxiosInstance
        .get(`/Reports-Resources/report/getAllThoughtLeadershipResourceType`)
        .then((res) => res.data)
    },
  })
}
export const useUpdateThoughtLeadershipResourcesBySitecoreIdMutation = () => {
  return useMutation({
    mutationFn: ({ body }) => {
      return clientPortalAxiosInstance
        .post(`/Reports-Resources/report/createThoughtLeadershipExcudeAccount`, body)
    },
  })
}